import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: "Combien de personnes peut accueillir Ty Gwennili ?",
    answer: "Ty Gwennili peut accueillir jusqu'à 6 personnes. La maison dispose de 3 chambres et 2 salles de bain. Elle convient aux familles avec enfants comme aux groupes d'amis.",
  },
  {
    question: "Est-ce proche de la plage ?",
    answer: "Oui, la plage de la Grève Blanche se trouve à 5 minutes à pied de la maison. C'est une grande plage de sable blanc, idéale pour la baignade et les activités nautiques. Le sentier côtier GR34 est lui aussi accessible à pied.",
  },
  {
    question: "Où se situe exactement la maison ?",
    answer: "La maison est située à Plouguerneau, dans le Finistère (29), en Bretagne. Brest est à environ 35 minutes en voiture, Landerneau à 40 minutes.",
  },
  {
    question: "Combien coûte la location ?",
    answer: "Les tarifs varient selon la période : à partir de 240 €/nuit hors saison (minimum 2 nuits), et à partir de 1 680 €/semaine en période estivale (juillet–août). Des frais de ménage s'ajoutent. Pour un séjour de plus de 7 nuits hors saison, un devis personnalisé est disponible sur demande.",
  },
  {
    question: "Y a-t-il un parking ?",
    answer: "Oui, Ty Gwennili dispose d'un parking privé attenant à la maison, inclus dans le tarif de location.",
  },
  {
    question: "Les animaux de compagnie sont-ils acceptés ?",
    answer: "Les animaux de compagnie ne sont en général pas acceptés. N'hésitez pas à nous contacter directement pour en discuter.",
  },
  {
    question: "Y a-t-il le Wifi ?",
    answer: "Oui, la maison est équipée du Wifi haut débit dans toutes les pièces, inclus dans le tarif.",
  },
  {
    question: "La maison est-elle adaptée aux enfants ?",
    answer: "Tout à fait. Le jardin est clos et sécurisé pour les plus petits. La Grève Blanche est une plage peu pentue, parfaite pour les enfants. La maison dispose aussi de jeux de société et d'un grand espace de vie.",
  },
  {
    question: "La maison est-elle disponible toute l'année ?",
    answer: "Ty Gwennili est disponible de fin mai à fin octobre. Cette période correspond aux beaux jours bretons, du printemps fleuri jusqu'aux dernières chaleurs de l'automne.",
  },
  {
    question: "Quelles sont les règles de la maison ?",
    answer: "La maison est non-fumeur à l'intérieur. Il est demandé de respecter le voisinage (pas de nuisances sonores après 22h) et de restituer la maison dans son état initial. Un inventaire est réalisé à l'arrivée et au départ.",
  },
];

const FaqItem = ({ question, answer }: { question: string; answer: string }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left bg-white hover:bg-gray-50 transition-colors"
        aria-expanded={open}
      >
        <span className="font-medium text-gray-800">{question}</span>
        <ChevronDown
          className={`h-5 w-5 text-gray-400 shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && (
        <div className="px-5 py-4 text-gray-600 leading-relaxed bg-gray-50 border-t border-gray-100">
          {answer}
        </div>
      )}
    </div>
  );
};

const FaqSection = () => {
  return (
    <div className="max-w-3xl mx-auto" id="faq">
      <h2 className="text-3xl font-semibold mb-4 text-center">Questions fréquentes</h2>
      <p className="text-center text-gray-600 mb-10">
        Tout ce que vous devez savoir avant de réserver votre séjour à Ty Gwennili.
      </p>
      <div className="space-y-3">
        {faqs.map((faq, index) => (
          <FaqItem key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
    </div>
  );
};

export default FaqSection;
